module.exports = __webpack_public_path__ + "img/Katarina_acc_03.494a22ac.jpg";